import { Attribute, Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AuthService } from '@app/core/auth';

@Directive({ selector: '[permission]' })
export class PermissionDirective implements OnInit {
  constructor(private el: ElementRef, private authService: AuthService) {
    //el.nativeElement.style.backgroundColor = 'yellow';
  }
  @Input('permission') permission: string;
  ngOnInit() {
    this.authService.getMyPermissions().subscribe((lstPermission) => {
      const isHasPermission = this.permission.includes(lstPermission);
      if (!isHasPermission) {
        return this.el.nativeElement.remove();
      }
    });
  }
}
